import React from "react";

// reactstrap components
import {
  Form,
  FormGroup,
  Input,
  Label,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  CardFooter,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledTooltip,
  InputGroupAddon,
  InputGroup,
  Container,
} from "reactstrap";

import {
  PanelHeader, 
  Button,
  // CardCategory
} from "components";

import Select from "react-select";
import PhoneInput from 'react-phone-number-input'


function TalentLaunchForm(props) {
    const { name2, name2State, 
            email2, email2State, 
            trait2State, selectedTraitValue2, traitOptions, 
            instagram2 } = props 

    const { submitted2, isBot, botChecked, talentMode } = props 

    const { checkName2, checkEmail2, selectTrait2, handleChange, handleLaunchSubmit } = props 

  return (
    <>
    <Row className='mt-4'>
        <Col lg="12">
            <Label className="form-control-label">Name
            <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                    id="name2"
                />
                <UncontrolledTooltip  
                placement="right" 
                target="name2" 
                delay={0}> 
                Enter your name 
                </UncontrolledTooltip>

            </Label>
            <FormGroup 
            className={"mt-2 " + name2State}
            >
                <Input
                type="text" 
                name="name2" 
                value={name2}
                placeholder="Your name"
                onBlur={e => checkName2(e )}
                onChange={e => checkName2(e)}
                valid={
                    name2State === "has-success"
                }
                invalid={
                    name2State === "has-danger"
                }
                />
            </FormGroup>
            </Col>
            <Col lg="12" >
            <Label className="form-control-label">Email
            <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                    id="email2"
                />
                <UncontrolledTooltip  
                placement="right" 
                target="email2" 
                delay={0}> 
                Enter your email address.  
                </UncontrolledTooltip>

            </Label>
            <FormGroup 
            className={"mt-2 " + email2State}
            >
                <Input
                type="email" 
                name="email2" 
                value={email2}
                placeholder="Your email"
                onBlur={e => checkEmail2(e)}
                onChange={e => checkEmail2(e)}
                valid={
                    email2State === "has-success"
                }
                invalid={
                    email2State === "has-danger"
                }
                />
            </FormGroup>
            </Col>
            <Col lg="12" >
            <Label className="form-control-label">Primary Talent
            <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                    id="selectedTrait2"
                />
                <UncontrolledTooltip  
                placement="right" 
                target="selectedTrait2" 
                delay={0}> 
                Choose the talent that best describes the main thing you do
                </UncontrolledTooltip>

            </Label>
            <FormGroup 
            className={"mt-2 " + trait2State}
            >
                <Select
                className="react-select primary wrap-cursor-pointer"
                classNamePrefix="react-select"
                placeholder="Choose Main Talent"
                name="selectedTrait2"
                value={selectedTraitValue2}
                options={traitOptions}
                onChange={value => selectTrait2(value) }
                />
            </FormGroup>
            </Col>

            
            <Col lg="12" >
            <FormGroup 
            // className={this.state.nameState}
            >
            <Label className="form-control-label">Instagram
            <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                    id="instagram2"
                />
                <UncontrolledTooltip  
                placement="right" 
                target="instagram2" 
                delay={0}> 
                Enter your instagram handle.  
                </UncontrolledTooltip>

            </Label>
                <Input
                type="text" 
                name="instagram2" 
                value={instagram2}
                placeholder="Your Instagram handle"
                onBlur={e => handleChange(e)}
                onChange={e => handleChange(e)}
                // valid={
                //   this.state.nameState === "has-success"
                // }
                // invalid={
                //   this.state.nameState === "has-danger"
                // }
                />
            </FormGroup>
            </Col>


            <Col xs={12} className="text-center">
            <Button style={{fontSize:"1rem"}} disabled={submitted2 || isBot || !botChecked} color={talentMode ? "primary" : "purple"}s ize="lg" block className={talentMode ? " title bg-gradient-livenyte" : " title bg-gradient-purple"}onClick={e => handleLaunchSubmit(e)}>
                {submitted2 ? 'Launch request sent' : 'Join'}
            </Button>
            </Col>
        </Row>
    </>
  );
}

export default TalentLaunchForm;
